import { Pass } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useUpdatePassQuery = (passId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/passes/${passId}`
	return useLazyQuery<Pass, void>(url, "PATCH")
}
